<script lang="ts">
    import {getInjector} from 'src/core';
    import {AnalyticsService} from './analytics.service';
    import EmbedContainer from './EmbedContainer.svelte';
    import type {EmbeddingParamsRequest} from 'src/features/erp-sutor/features/analytics/types';

    export let id: string;
    export let params: EmbeddingParamsRequest;
    export let type: 'dashboard' | 'chard';

    const service = getInjector().getByClass(AnalyticsService);
    const embedUrl = type === 'dashboard' ? service.getEmbeddedDashboardUrl(id, params) : service.getEmbeddedChartUrl(id, params);
</script>

<EmbedContainer {embedUrl} />